// extracted by mini-css-extract-plugin
module.exports = {"prompt":"index_prompt__3D9uT","tip":"index_tip__3iNag"};